// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"71":"e7fb07113746d051","415":"abb1e3aa3dd59326"}[chunkId] + ".js";
};